<template>
  <header class="p-header">
    <section class="c-visible-pc" v-if="$store.state.isPc">
      <div class="content">
        <div class="logo" @click="toUrl('/index')">
          <img class="img" src="../assets/index/logo-plus.png" />
        </div>
        <div class="c-p-r menus">
          <div
            tag="a"
            class="menu-item"
            v-for="i in menu"
            :key="i.name"
            @click="toUrl(i.url)"
            :class="{ 'actived': activedPath === i.url }">
            {{ i.name }}
            <div class="c-c-text-color nav-list" @click.stop>
              <div v-if="i.name === '产品与服务'" class="c-d-f">
                <div>
                  <p class="c-c-text-grey nav-link" v-for="child in i.child.slice(0, 6)" :key="child.name" @click.stop="toChildUrl(child.link, i.name, child.isPage)">{{child.name}}</p>
                </div>
                <div>
                  <p class="c-c-text-grey nav-link" v-for="child in i.child.slice(6)" :key="child.name" @click.stop="toChildUrl(child.link, i.name, child.isPage)">{{child.name}}</p>
                </div>
              </div>
              <div class="c-d-f c-fw-w" v-else>
                <p class="c-c-text-grey nav-link" v-for="child in i.child" :key="child.name" @click.stop="toChildUrl(child.link, i.name, child.isPage)">{{child.name}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="c-visible-mobile" v-if="!$store.state.isPc">
      <div class="c-pl-12 c-pr-12 c-p-r mobile-content">
        <img class="logo-img" src="../assets/index/logo-plus.png" @click="toUrl('/index')"/>
        <button @click="clickMenu" class="logo-btn">
          <img :src="require('../assets/header/header-btn.png')">
        </button>
        <transition name="fade">
          <div v-show="isShowMenu" class="c-fs-15 menu-wrap" :class="{'menu-wrap-actived' : isShowMenu === true}">
            <div class="menu-btn-wrap">
              <button @click="clickMenu" class="logo-btn">
                <img :src="require('../assets/header/header-btn.png')">
              </button>
            </div>
            <div class="c-d-f c-jc-sb c-ai-c cm-border select-wrap" @click="toUrl('/webMonitor')">
              <span>产品与服务</span>
              <div class="arrow-wrap" @click.stop="selectItem(1)">
                <img class="arrow" :class="{ 'arrow-up': selectIndex === 1 }" src="../assets/header/header-arrow-down.png">
              </div>
            </div>
            <div class="select-item" :class="{ 'item-actived': selectIndex === 1 }">
              <ul class="c-c-text-grey c-fs-13 select-menu">
                <li v-for="item in productsList" :key="item.name" @click="toUrl(item.link)">{{item.name}}</li>
              </ul>
            </div>
             <div class="c-d-f c-jc-sb c-ai-c cm-border select-wrap" @click="toUrl('/operations_itsm')">
              <span>运维管理</span>
              <div class="arrow-wrap" @click.stop="selectItem(6)">
                <img class="arrow" :class="{ 'arrow-up': selectIndex === 6 }" src="../assets/header/header-arrow-down.png">
              </div>
            </div>
            <div class="select-item" :class="{ 'item-actived': selectIndex === 6 }">
              <ul class="c-c-text-grey c-fs-13 select-menu">
                <li v-for="item in operationsList" :key="item.name" @click="toUrl(item.link)">{{item.name}}</li>
              </ul>
            </div>
            <div class="c-d-f c-jc-sb c-ai-c cm-border select-wrap" @click="toUrl('/resolution')">
              <span>解决方案</span>
              <div class="arrow-wrap" @click.stop="selectItem(2)">
                <img class="arrow" :class="{ 'arrow-up': selectIndex === 2 }" src="../assets/header/header-arrow-down.png">
              </div>
            </div>
            <div class="select-item" :class="{ 'item-actived': selectIndex === 2 }">
              <ul class="c-c-text-grey c-fs-13 select-menu">
                <li v-for="item in resolutionList" :key="item.name" @click="toUrl(item.link)">{{item.name}}</li>
              </ul>
            </div>
            <!-- <div class="c-d-f c-jc-sb c-ai-c cm-border select-wrap" @click="toUrl('/support')">
              <span>认证培训</span>
              <div class="arrow-wrap" @click.stop="selectItem(3)">
                <img class="arrow" :class="{ 'arrow-up': selectIndex === 3 }" src="../assets/header/header-arrow-down.png">
              </div>
            </div>
            <div class="select-item" :class="{ 'item-actived': selectIndex === 3 }">
              <ul class="c-c-text-grey c-fs-13 select-menu">
                <li v-for="item in supportList" :key="item.name" @click="toUrl(item.link)">{{item.name}}</li>
              </ul>
            </div> -->
            <div class="c-d-f c-jc-sb c-ai-c cm-border select-wrap" @click="toUrl('/products')">
              <span>技术支持</span>
              <!-- <img class="arrow" :class="{ 'arrow-up': selectIndex === 3 }" src="../assets/header/header-arrow-down.png" @click.stop="selectItem(3)"> -->
            </div>
            <div class="c-d-f c-jc-sb c-ai-c cm-border select-wrap" @click="toUrl('/partners')">
              <span>合作伙伴</span>
              <div class="arrow-wrap" @click.stop="selectItem(4)">
                <!-- <img class="arrow" :class="{ 'arrow-up': selectIndex === 4 }" src="../assets/header/header-arrow-down.png"> -->
              </div>
            </div>
            <!-- <div class="select-item" :class="{ 'item-actived': selectIndex === 4 }">
              <ul class="c-c-text-grey c-fs-13 select-menu">
                <li v-for="item in partnersList" :key="item.name" @click="toMobileChildUrl(item.linkM, item.isPage, 1)">{{item.name}}</li>
              </ul>
            </div> -->
            <div class="c-d-f c-jc-sb c-ai-c cm-border select-wrap" @click="toUrl('/about')">
              <span>关于我们</span>
              <div class="arrow-wrap" @click.stop="selectItem(5)">
                <img class="arrow" :class="{ 'arrow-up': selectIndex === 5 }" src="../assets/header/header-arrow-down.png">
              </div>
            </div>
            <div class="select-item" :class="{ 'item-actived': selectIndex === 5 }">
              <ul class="c-c-text-grey c-fs-13 select-menu">
                <li v-for="item in aboutList" :key="item.name" @click="toMobileChildUrl(item.linkM, item.isPage, 2)">{{item.name}}</li>
              </ul>
            </div>
          </div>
        </transition>
        <div class="menu-mask" v-show="isShowMenu" @click.stop="isShowMenu = false">
        </div>
      </div>
    </section>
  </header>
</template>

<script>
import { mapState } from 'vuex'
import { headerMenu, productsList, supportList, aboutList, resolutionList, partnersList, operationsList } from '../constants/header.constants'
export default {
  data () {
    return {
      menu: headerMenu,
      isShowMenu: false,
      selectIndex: 0,
      productsList: productsList,
      aboutList: aboutList,
      resolutionList: resolutionList,
      supportList: supportList,
      partnersList: partnersList,
      operationsList: operationsList
    }
  },
  computed: {
    ...mapState(['activedPath'])
  },
  methods: {
    clickMenu () {
      this.isShowMenu = !this.isShowMenu
      this.selectIndex = 0
    },
    toUrl (url) {
      if (this.activedPath !== url) {
        this.$router.push(url)
      }
      this.hideDropdwonMenus()
    },
    selectItem (index) {
      this.selectIndex = (this.selectIndex === index ? 0 : index)
    },
    hideDropdwonMenus () {
      this.isShowMenu = false
    },
    // pc 统一判断是否页面内锚点跳转
    toChildUrl (url, name, isPage = false) {
      if (name === '合作伙伴' && !isPage) {
        if (this.activedPath !== '/partners') this.$router.push('/partners')
        setTimeout(() => {
          const distance = document.getElementById(url).offsetTop
          document.documentElement.scrollTop = distance - 120
          document.body.scrollTop = distance - 120
        }, 100)
      } else if (name === '关于我们' && !isPage) {
        if (this.activedPath !== '/about') this.$router.push('/about')
        setTimeout(() => {
          const distance = document.getElementById(url).offsetTop
          document.documentElement.scrollTop = distance - 120
          document.body.scrollTop = distance - 120
        }, 100)
      } else {
        if (this.activedPath !== url) {
          this.$router.push(url)
        }
      }
      this.hideDropdwonMenus()
    },
    // 移动端合作伙伴和关于我们单独跳转
    toMobileChildUrl (url, isPage = false, type) {
      if (type === 1 && !isPage) {
        if (this.activedPath !== '/partners') this.$router.push('/partners')
        setTimeout(() => {
          const distance = document.getElementById(url).offsetTop
          document.documentElement.scrollTop = distance - 60
          document.body.scrollTop = distance - 60
        }, 300)
      } else if (type === 2 && !isPage) {
        if (this.activedPath !== '/about') this.$router.push('/about')
        setTimeout(() => {
          const distance = document.getElementById(url).offsetTop
          document.documentElement.scrollTop = distance - 60
          document.body.scrollTop = distance - 60
        }, 300)
      } else {
        if (this.activedPath !== url) {
          this.$router.push(url)
        }
      }
      this.hideDropdwonMenus()
    }
  }
}
</script>

<style lang="scss">
.p-header {
  position: fixed;
  top: 0;
  width: 100%;
  height: 44px;
  @media screen and (min-width: $min-width-standard) {
    height: 90px;
  }
  background: white;
  border-bottom: 1px solid #EAEEF5;
  box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
  z-index: 10;
  .fade-enter-active, .fade-leave-active {
    transition: all .3s;
  }
  .fade-enter, .fade-leave-to {
    transform: translateX(100%);
  }
  .content {
    max-width: 1179px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    .logo {
      display: flex;
      align-items: center;
      .img {
        width: 90px;
        cursor: pointer;
      }
    }
    .menus {
      display: flex;
      line-height: 90px;
      .menu-item {
        position: relative;
        margin-left: 32px;
        color: $text-color;
        font-size: 14px;
        text-decoration: none;
        cursor: pointer;
        transition: before 0.3s ease-in-out;
        &::before {
          content: "";
          width: 0;
          height: 3px;
          background: $orange;
          position: absolute;
          bottom: 0;
          left: 0;
          transition: all 0.3s;
        }
        &:hover::before {
          width: 100%;
        }
        &.actived, &:hover {
          color: $orange;
        }
        &.actived::before {
          width: 100%;
        }
        &:hover > .nav-list {
          visibility: visible;
          opacity: 1;
        }
        .nav-list {
          width: 418px;
          line-height: 0;
          padding-right: 30px;
          position: absolute;
          top: calc(100% + 1px);
          background-color: white;
          cursor: default;
          box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.4s ease;
          .nav-link {
            padding: 0;
            line-height: 22px;
            margin-left: 30px;
            margin-top: 30px;
            cursor: pointer;
            &:hover {
              color: $orange;
            }
          }
          & .nav-link:nth-last-of-type(1) {
            margin-bottom: 30px;
          }
        }
      }
      & .menu-item:nth-of-type(1) .nav-list {
        transform: translateX(-40%);
        @media screen and (max-width: 1476px) {
          // left: -200%;
        }
      }
      & .menu-item:nth-of-type(2) .nav-list {
        width: 174px;
        transform: translateX(-33%);
      }
      & .menu-item:nth-of-type(3) .nav-list {
        width: 221px;
        transform: translateX(-36%);
      }
      & .menu-item:nth-of-type(4) .nav-list {
        width: 146px;
        transform: translateX(-33%);
      }
      & .menu-item:nth-of-type(5) .nav-list {
        width: 120px;
        transform: translateX(-28%);
        @media screen and (max-width: 1200px) {
          transform: translateX(0%);
          right: 0;
        }
      }
      & .menu-item:nth-of-type(6) .nav-list {
        width: 160px;
        transform: translateX(-36%);
        @media screen and (max-width: 1280px) {
          transform: translateX(0%);
          right: 0;
        }
      }
    }
  }
  .mobile-content {
    width: 100%;
    height: 44px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo-img {
      width: 55.5px;
    }
    .logo-btn {
      img {
        width: 34px;
      }
    }
    .menu-btn-wrap {
      height: 44px;
      padding-left: 20px;
      display: flex;
      align-items: center;
      // border-bottom: 1px solid rgba(181, 196, 232, 0.4);
    }
    .menu-mask {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background:rgba(0, 0, 0, 0.4);
      z-index: 8;
    }
    .menu-wrap {
      width: 74%;
      height: 100vh;
      overflow: scroll;
      background: white;
      position: absolute;
      right: 0;
      top: 0;
      z-index: 9;
      box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
      overflow: hidden;
      .select-wrap {
        width: 100%;
        height: 54px;
        padding-left: 24px;
        border-bottom: 1px solid rgba(181, 196, 232, 0.4);
        .arrow-wrap {
          width: 80px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .arrow {
          width: 16px;
          &.arrow-up {
            transform: rotate(180deg);
          }
        }
      }
      .select-item {
        height: 0;
        background-color: $background-color;
        transition: height .3s ease;
        overflow: hidden;
        &.item-actived {
          height: 458px;
        }
        .select-menu {
          list-style: none;
          li {
            padding-left: 24px;
            padding-top: 21px;
          }
        }
      }
      & .item-actived:nth-of-type(5) {
        height: 102px;
      }
      & .item-actived:nth-of-type(7) {
        height: 58px;
      }
      & .item-actived:nth-of-type(9) {
        // height: 136px;
        height: 176px;
      }
       & .item-actived:nth-of-type(11) {
        height: 102px;
      }
    }
  }
}
</style>
